<template>
  <DialogComponent
    class="form-modal"
    :visible.sync="modalVisible"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
    v-loading="scheduleProcessing"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Schedule a Report</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="scheduleOperation"
            >Schedule</el-button
          >
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-input v-model="form.name" placeholder="Name">
            <template slot="prefix">Name</template>
          </el-input>
        </el-col>
        <el-col :span="1"></el-col>
        <el-col :span="11">
          <dads-select v-model="form.frequency" placeholder="Frequency">
            <el-option
              v-for="{ label, value } of frequencyOptions"
              :key="value"
              :label="label"
              :value="value"
            />

            <template slot="prefix">Frequency</template>
          </dads-select>
        </el-col>
      </div>

      <h2 class="form-section-header">Recipients</h2>
      <el-input v-model="form.recipients" placeholder="Enter emails">
        <template slot="prefix"> Recipients </template>
      </el-input>
      <el-tag class="mb-10">
        <i class="el-icon-info"></i>
        Use commas to separate multiple emails.
      </el-tag>

      <scheduled-report-params
        title="Current filter settings"
        :params="filterSettings"
      />
    </el-form>
  </DialogComponent>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";
import DialogComponent from "@/components/CustomModalComponent";
import DadsSelect from "@/components/select";
import ScheduledReportParams from "./ScheduledReportParams";

export default {
  name: "ScheduleReportModal",

  props: {
    modalVisible: { required: true },
    filterSettings: { required: true },
  },

  components: {
    DialogComponent,
    DadsSelect,
    ScheduledReportParams,
  },

  data() {
    return {
      scheduleProcessing: false,

      frequencyOptions: [
        { label: "Daily", value: "DAILY" },
        { label: "Weekly", value: "WEEKLY" },
        { label: "Monthly", value: "MONTHLY" },
      ],

      form: {
        name: "",
        frequency: "",
        recipients: "",
      },
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    scheduleOperation() {
      this.schedulePorcessing = true;

      const queryTypeModuleMap = {
        callHistory: "Call Records",
        queueSummary: "Queue Summary",
        agentActivity: "Agent Activity",
        queueLogReport: "Queue Log",
        callStatistics: "Call Statistics",
      };

      // 'type' field for Queues
      // 'queryType' field for Call Summary
      const { type, queryType } = this.filterSettings.query;
      let module = queryTypeModuleMap[queryType];

      if (!module) {
        module = queryTypeModuleMap[type];
      }

      const createBody = {
        tenantId: this.selectedTenant.id,
        ...this.form,
        parameters: this.filterSettings,
        creatorEmail: this.user.email,
        module,
      };

      createBody.recipients = createBody.recipients
        .replace(/\s/g, "")
        .split(",");

      feathersClient
        .service("scheduled-reports")
        .create(createBody)
        .then(() => {
          this.$notify({
            title: "Success",
            message: "Scheduled successfully",
            type: "success",
          });
          this.schedulePorcessing = false;
          this.cancelOperation();
        })
        .catch((error) => {
          if (error.hasOwnProperty("errors")) {
            this.$notify({
              title: error.message,
              message: error.errors[Object.keys(error.errors)[0]],
              type: "error",
            });
          } else {
            this.$notify({
              title: error.name,
              message: error.message,
              type: "error",
            });
          }

          this.scheduleProcessing = false;
        });
    },

    cancelOperation() {
      this.form = {
        name: "",
        frequency: "",
        recipients: "",
      };
      this.userQuery = "";
      this.userOptions = [];

      this.$emit("cancelOperation");
    },
  },

  created() {},
};
</script>

<style lang="scss" scoped>
.el-form {
  max-width: 600px;
  margin: 0 auto;
}
</style>
